/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Modal from '@bd/bdui-modal';
import RawPlatMap from '@bd/bdui-platmap';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import HomeCard from '../../components/HomeCard';
import LotCard from '../../components/LotCard';
import { colors } from '../../styles';

const PlatMap = withData(
  {
    community: true,
    lots: true,
    homes: true,
  },
  {
    community: true,
  },
)(RawPlatMap);

const modalStyles = css`
  position: absolute;
  top: 30px;
  width: 75vw;
  left: 12.5vw;
  height: auto;
  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(63,63,63,.85);
  }
  @media (max-width: 991px) {
    top: 15px;
    left: 15px;
    right: 15px;
    width: auto;
    margin: 0;
  }
  .SitePlanModal_header {
    background-color: ${colors.brand2};
    background-size: 25% auto;
    background-repeat: repeat-y;
    background-position: left top;
    z-index: 2;
    position: relative;
    padding: 50px 30px 30px 30px;
    @media (max-width: 991px) {
      padding: 10px 30px 10px 10px;
    }
    img {
      width: 100%;
      height: auto;
      float: left;
      margin: 0 30px 0 0;
      @media (max-width: 991px) {
        display: none;
      }
    }
    .SitePlanModal_title {

      font-size: 36px;
      font-weight: 800;
      color: #FFFFFF;
      line-height: 40px;
      margin: 0;
      @media (max-width: 991px) {
        font-size: 24px;
        line-height: 24px;
      }
    }
    .SitePlanModal_postTitle{
      display: block;
      font-size: 24px;
      color: ${colors.neutral};
      @media (max-width: 991px) {
        font-size: 18px;
      }
    }
  }
  .SitePlanModal_body {
    padding: 30px;
    position: relative;
    z-index: 2;
    @media (max-width: 991px) {
      padding: 15px 0;
    }
    .btn {
      background-color: ${colors.brand1};
      background-image: none;
      padding: 10px 15px;
    }
  }
  .SitePlanModal_footer {
    background-color: #000000;
    padding: 20px 30px;
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 800;
    @media (min-width: 992px) {
      display: none;
    }
    a {
      background-color: ${colors.brand2};
      color: #FFFFFF;
      padding: 8px 15px;
      font-weight: 800;
      font-size: 13px;
      line-height: 15px;
      display: flex;
      align-items: center;
      img {
        margin: 0 10px 0 0;
      }
    }
  }

  .invalid-feedback {
    color: #FFFFFF;
  }

  a.modal-close {
    position: absolute;
    z-index: 10;
    line-height: 30px;
    color: ${colors.brand1};
    font-size: 40px;
    top: 10px;
    right: 10px;
    @media(min-width: 768px){
      top: 15px;
      right: 15px;
      font-size: 50px;
    }
  }

  .SitePlanModal_platMap .leaflet-container {
    height: 600px;
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background-color: rgba(0,0,0, 0.3);
  overflow-y: auto;
  z-index: 1004;
`;

class SitePlanModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    e.preventDefault();
    this.setState({ modalIsOpen: true });
  }

  closeModal(e) {
    e.preventDefault();
    this.setState({ modalIsOpen: false });
  }

  render() {
    const { children, community, buttonClassName } = this.props;
    return (
      <div>
        <span role="button" tabIndex={0} className={buttonClassName} onClick={this.openModal}>
          {children}
        </span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <a href="" onClick={this.closeModal} className="modal-close">&times;</a>
          <div className="SitePlanModal_header">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <h3 className="SitePlanModal_title">{_.get(community, 'name')} Site Plan</h3>
                </div>
              </div>
            </div>
          </div>
          <div className="SitePlanModal_body">
            <div className="container">
              <div className="row">
                <div className="col-12 SitePlanModal_platMap">
                  <PlatMap
                    shapeStatusStyles={{
                      home: {
                        active: {
                          color: 'rgb(255,193,7)',
                        },
                        'under-construction': {
                          color: 'rgb(255,193,7)',
                        },
                      },
                    }}
                    shapes
                    boundarySize={1}
                    community={community}
                    pin={{
                      iconUrl: '/images/icon-map-pin-white.svg',
                      iconSize: [21, 30],
                      iconAnchor: [11, 30],
                      popupAnchor: [0, -35],
                    }}
                    pins={[
                      {
                        iconUrl: '/images/icon-map-pin-forbes.svg',
                        when: marker => marker.isLot,
                      },
                    ]}
                    popup={({ marker }) => (
                      <div className="home-popup HomeCardsList Vertical">
                        {
                          marker.type === 'home' &&
                          <HomeCard home={marker} />
                        }
                        {
                          marker.type === 'lot' &&
                          <LotCard lot={marker} />
                        }
                      </div>
                    )}
                    tooltip={marker => (
                      <div>
                        {
                          !marker.isLot &&
                          <span>
                            Available Home
                            <br />
                            {marker.address.streetAddress}
                          </span>
                        }

                        {
                          marker.isLot &&
                          <span>
                            Available Lot
                            <br />
                            {marker.address.streetAddress}
                          </span>
                        }
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

SitePlanModal.propTypes = {
  community: PropTypes.object,
  children: PropTypes.node,
  buttonClassName: PropTypes.string,
};

SitePlanModal.defaultProps = {
  community: undefined,
  children: undefined,
  buttonClassName: undefined,
};

export default SitePlanModal;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/Map.js